import React, { useEffect, useRef, useState } from 'react';
import { MaterialIcons, Button } from '@iclinic/design-system';

import {
  StyledDialog,
  DialogContent,
  ButtonStyled,
  TextContent,
  Title,
  Description,
  ActionArea,
  ButtonClose,
  ImageWrapper,
} from './GlicPopoverCTA.styles';
import GlicLogo from '../GlicLogo';
import images from 'shared/paths/images';

const { InfoOutlined, Launch } = MaterialIcons;

const DEBOUNCE_DELAY = 400;

export default function GlicPopoverCTA() {
  const buttonRef = useRef<HTMLDivElement>(null);
  const [positionTop, setPositionTop] = useState('0px');
  const [positionLeft, setPositionLeft] = useState('0px');
  const [isOpen, setIsOpen] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleOpen = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    const rect = buttonRef.current?.getBoundingClientRect() || {
      top: 0,
      left: 0,
    };
    const buttonSize = 32;
    const spacingLeft = 25;
    const positionArrow = 16;
    const rectLeft = rect.left + buttonSize + spacingLeft;
    const rectTop = rect.top - positionArrow;
    setPositionTop(`${rectTop}px`);
    setPositionLeft(`${rectLeft}px`);
    setIsOpen(true);
  };

  const handleClose = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setIsOpen(false);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      handleClose();
    }, DEBOUNCE_DELAY);
  };

  const handleTrigger = () => {
    if (isOpen) {
      handleClose();
      return;
    }
    handleClose();
  };

  const handleOpenGlic = () => {
    window.open('https://app.gliconline.com.br/usuarios/cadastre-se', '_blank');
  };

  useEffect(
    () => () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    },
    [],
  );

  return (
    <>
      <div ref={buttonRef}>
        <ButtonStyled
          variant="outlined"
          size="small"
          onMouseEnter={handleOpen}
          onMouseLeave={handleMouseLeave}
          onClick={handleTrigger}
        >
          <InfoOutlined />
        </ButtonStyled>
      </div>
      <StyledDialog
        keepMounted={false}
        disableEnforceFocus
        disableAutoFocus
        disablePortal
        hideBackdrop
        disableScrollLock
        open={isOpen}
        positionTop={positionTop}
        positionLeft={positionLeft}
        onMouseLeave={handleMouseLeave}
        onMouseEnter={handleOpen}
      >
        <DialogContent>
          <TextContent>
            <GlicLogo />
            <Title>Acompanhe a rotina de pacientes em tempo real</Title>
            <Description>
              Experimente o Glic e tenha acesso aos dados compartilhadas por
              seus pacientes. Relatórios e gráficos detalhados, em tempo real,
              para melhorar ainda mais seu atendimento.
            </Description>
            <ActionArea>
              <ButtonClose
                variant="contained"
                size="medium"
                onClick={handleClose}
              >
                Agora Não
              </ButtonClose>
              <Button
                variant="contained"
                size="medium"
                endIcon={<Launch />}
                onClick={handleOpenGlic}
              >
                Experimentar Glic
              </Button>
            </ActionArea>
          </TextContent>
          <ImageWrapper>
            <img
              src={images.records.glicExample}
              alt="Exemplo de página do paciente na plataforma Glic"
            />
          </ImageWrapper>
        </DialogContent>
      </StyledDialog>
    </>
  );
}
